import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import { Company } from '../companies/company.model';
import { Contact } from '../contacts/contact.model';
import { CompanyService } from '../companies/company.service';
import { ContactService } from '../contacts/contact.service';
import { Subject } from 'rxjs/Subject';
import { ProjectService } from '../projects/project.service';
import { Project } from '../projects/project.model';


@Injectable()
export class SearchService {

  foundCompanies: Company[] = [];
  foundContacts: Contact[] = [];
  foundOpportunities: Project[] = [];
  foundDeals: Project[] = [];
  // foundProjects: Contact[] = [];
  searchTerm$ = new Subject<string>();

  constructor(private companyService: CompanyService,
    private contactService: ContactService,
    private projectService: ProjectService) { }


  searchCompanies(terms: Observable<string>) {

    return terms
      .filter((query: string) => query.length > 1)
      .debounceTime(750)
      .distinctUntilChanged()
      .switchMap(term => this.companyService.findTopNCompanies(term, 20));

  }

  searchContacts(terms: Observable<string>) {

    return terms
      .filter((query: string) => query.length > 1)
      .debounceTime(750)
      .distinctUntilChanged()
      .switchMap(term => this.contactService.findTopNContacts(term, term, 20));

  }

  searchProjects(terms: Observable<string>) {

    return terms
      .filter((query: string) => query.length > 1)
      .debounceTime(750)
      .distinctUntilChanged()
      .switchMap(term => this.projectService.findTopNProjects(term, 'all', 20));

  }

  // searchContacts(terms: Observable<string>) {

  //   return terms
  //     .filter((query: string) => query.length > 1)
  //     .debounceTime(500)
  //     .distinctUntilChanged()
  //     .switchMap(term => this.contactService.findTopNContacts(term, term, 20));

  // }
}



// WEBPACK FOOTER //
// ./client/app/features/search/search.service.ts